import React from 'react';
import { Container, Row, Col } from 'react-grid-system';
import './App.css';

export const footerLinks = [
  { label: 'Instagram', href: 'https://www.instagram.com/maria.chimi/' },
  { label: 'Are.na', href: 'https://www.are.na/maria-chimishkyan' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/mariachimi' },
  { label: 'hi@mariachimi.com', href: null },
];

function Footer({ bgColor = '#000', visible = true }) {
  const dark = bgColor === '#000' || bgColor === '#085C34';
  const textClass = dark ? 'subhead-white' : 'subhead-black';
  const linkClass = dark ? 'footer-white' : 'footer-black';

  return (
		<div className="footer" style={{ backgroundColor: bgColor, opacity: visible ? 1 : 0 }}>
		  <div className="inner-wrapper">
			<Container fluid className="page-pad" style={{ position: 'relative', zIndex: 2 }}>
				<Row>
					{footerLinks.map(({ label, href }) => (
						<Col sm={3} key={label}>
							<div className={textClass} style={{ textTransform: 'none' }}>
								{href ? <a href={href} className={linkClass}>{label}</a> : label}
							</div>
						</Col>
					))}
				</Row>
			</Container>
        </div>
		  </div>
  );
}

export default Footer;
